var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurancePolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7996 6H13.1996C11.2114 6 9.59961 8.01472 9.59961 10.5V37.5C9.59961 39.9853 11.2114 42 13.1996 42H34.7996C36.7878 42 38.3996 39.9853 38.3996 37.5V10.5C38.3996 8.01472 36.7878 6 34.7996 6Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23C30 22.7348 29.8946 22.4804 29.7071 22.2929C29.5196 22.1054 29.2652 22 29 22H26V19C26 18.7348 25.8946 18.4804 25.7071 18.2929C25.5196 18.1054 25.2652 18 25 18H23C22.7348 18 22.4804 18.1054 22.2929 18.2929C22.1054 18.4804 22 18.7348 22 19V22H19C18.7348 22 18.4804 22.1054 18.2929 22.2929C18.1054 22.4804 18 22.7348 18 23V25C18 25.2652 18.1054 25.5196 18.2929 25.7071C18.4804 25.8946 18.7348 26 19 26H22V29C22 29.2652 22.1054 29.5196 22.2929 29.7071C22.4804 29.8946 22.7348 30 23 30H25C25.2652 30 25.5196 29.8946 25.7071 29.7071C25.8946 29.5196 26 29.2652 26 29V26H29C29.2652 26 29.5196 25.8946 29.7071 25.7071C29.8946 25.5196 30 25.2652 30 25V23Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePolicy);
export default __webpack_public_path__ + "static/media/insurance_policy.cb304fac0e025e202d43cb7062848655.svg";
export { ForwardRef as ReactComponent };